import { Button, HStack, useToast, VStack, Text, Checkbox, Box, Collapse, Flex } from "@chakra-ui/react";
import SelectGroupBy from "./select_group_by";
import ModalSelectManagers from "./modal_select_managers";
import ModalSelectPartners from "./modal_select_partners";
import SelectOrganization from "./payments_page/select_organization";
import SelectLegalEntity from "./order_suppliers_page/select_legal_entity";
import SelectStage from "./order_suppliers_page/select_stage";
import SelectPeriod from "./select_period";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import baseUrl from "../vars";
import { authFetch } from "../auth/auth";
import SelectDateMonth from "./select_date_month";
import SelectDateDays from "./select_date_days";
import SelectDateYear from "./select_date_year";
import SelectCounteragent from "./orders_page/select_counteragent";
import SelectAccountNumber from "./orders_page/select_account_number";
import SelectSection from "./select_section";
import { useEffect, useState, useRef } from "react";
import SelectTypeOrder from "./select_type_order";
import IsReturnAndPaid from "./is_return_and_paid";
import IsReturnAndPaidOpen from "./is_return_and_paid_open";
import SelectGroupByOrders from "./orders_page/select_group_by_orders"
import SelectGroupByPDZ from "./pdz_page/select_group_by_pdz"
import ModalSelectStaffYears from "./modal_select_staff_years";
import ShipmentPercentFilter from "./orders_page/shipment_percent_filter";
import SelectBackup from "./select_backups";
import SelectBind from "./select_bind";

const FiltersGrid = observer(({ page, renderButtons }) => {
  const { pageStore } = useStores();
  const [loading, setLoading] = useState(false);

  const toast = useToast();

  const [requestTime, setRequestTime] = useState(0);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const timerRef = useRef(null);

  const handleCancel = () => {
    if (pageStore.abortControllerRef) {
      pageStore.abortControllerRef.abort();
      console.log('Нажата кнопка отмены');
    }
  };


  const startTimer = () => {
    setIsTimerActive(true);
    const startTime = Date.now();
    setRequestTime(0);
    pageStore.setRequestTime(0);

    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setRequestTime((Date.now() - startTime) / 1000);
      pageStore.setRequestTime((Date.now() - startTime) / 1000);
    }, 50);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setIsTimerActive(false);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const params = new URLSearchParams();
  if (pageStore.selected_managers && pageStore.selected_managers.length) {
    pageStore.selected_managers.forEach((manager) =>
      params.append("managers", manager)
    );
  }

  const fetchAllOpenRev = async () => {
    setLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataOpenRev();
    let page = 0;
    const count = 1000;
    let total = 0;

    try {
      while (true) {
        await new Promise(resolve => setTimeout(resolve, 0));
        const query = new URLSearchParams(params.toString());

        if (pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year) {
          const start = new Date(
            pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("start", start);
        }

        if (pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year) {

          const date = new Date(
            pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year
          )
          const end = [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0"),
          ].join("-");
          query.append("end", end);
        }

        if (pageStore.selected_view_open && (pageStore.selected_view_open.isReturn || pageStore.selected_view_open.isNotReturn)) {
          if (pageStore.selected_view_open.isReturn && !pageStore.selected_view_open.isNotReturn) query.append("isReturn", 1);
          else if (!pageStore.selected_view_open.isReturn && pageStore.selected_view_open.isNotReturn) query.append("isReturn", 0);
          else query.append("isReturn", 3)
        }
        if (pageStore.selected_view_open && pageStore.selected_view_open.isFullShipment) {
          query.append("isFullShipment", "true");
        }
        if (pageStore.selected_view_open && pageStore.selected_view_open.isPartialShipment) {
          query.append("isPartialShipment", "true");
        }
        if (pageStore.selected_one_department)
          query.append("departament", pageStore.selected_one_department);
        if (pageStore.selected_organization)
          query.append("orgs", pageStore.selected_organization);
        if (pageStore.selected_staff_years)
          query.append("staff_year", pageStore.selected_staff_years)

        query.append("page", page);
        query.append("count", count);

        const res = await authFetch(`${baseUrl}/api/openRev?${query}`, {
          method: "GET",
          signal: signal,
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${pageStore.token}`,
            "X-Database": pageStore.select_backup != "" ? "temp" : "main"
          },
        });
        const json = await res.json();
        const data = json.data || [];
        if (page === 0) total = json.total || 0;

        pageStore.addDataOpenRev(data);
        //if (data.length < count || pageStore.data_payments.length >= total)
        break;
      }
    } catch (err) {
      toast({
        title: "Ошибка загрузки открытий",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.abortControllerRef = null;
      pageStore.setLoading(false)
      setLoading(false);
      stopTimer();
    }
  };

  const fetchAllOpenProfit = async () => {
    setLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataOpenProfit();
    let page = 0;
    const count = 1000;
    let total = 0;

    try {
      while (true) {
        await new Promise(resolve => setTimeout(resolve, 0));
        const query = new URLSearchParams(params.toString());

        if (pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year) {
          const start = new Date(
            pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("start", start);
        }

        if (pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year) {

          const date = new Date(
            pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year
          )
          const end = [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0"),
          ].join("-");
          query.append("end", end);
        }

        if (pageStore.selected_view_open && (pageStore.selected_view_open.isReturn || pageStore.selected_view_open.isNotReturn)) {
          if (pageStore.selected_view_open.isReturn && !pageStore.selected_view_open.isNotReturn) query.append("isReturn", 1);
          else if (!pageStore.selected_view_open.isReturn && pageStore.selected_view_open.isNotReturn) query.append("isReturn", 0);
          else query.append("isReturn", 3)
        }
        if (pageStore.selected_view_open && pageStore.selected_view_open.isFullShipment) {
          query.append("isFullShipment", "true");
        }
        if (pageStore.selected_view_open && pageStore.selected_view_open.isPartialShipment) {
          query.append("isPartialShipment", "true");
        }
        if (pageStore.selected_one_department)
          query.append("departament", pageStore.selected_one_department);
        if (pageStore.selected_organization)
          query.append("orgs", pageStore.selected_organization);
        if (pageStore.selected_staff_years)
          query.append("staff_year", pageStore.selected_staff_years)

        query.append("page", page);
        query.append("count", count);

        const res = await authFetch(`${baseUrl}/api/openProfit?${query}`, {
          method: "GET",
          signal: signal,
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${pageStore.token}`,
            "X-Database": pageStore.select_backup != "" ? "temp" : "main"
          },
        });
        const json = await res.json();
        const data = json.data || [];
        if (page === 0) total = json.total || 0;

        pageStore.addDataOpenProfit(data);
        //if (data.length < count || pageStore.data_payments.length >= total)
        break;
      }
    } catch (err) {
      toast({
        title: "Ошибка загрузки открытий",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.abortControllerRef = null;
      pageStore.setLoading(false)
      setLoading(false);
      stopTimer();
    }
  };


  const fetchAllPayments = async () => {
    setLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataPayments();
    let page = 0;
    const count = 1000;
    let total = 0;

    try {
      while (true) {
        await new Promise(resolve => setTimeout(resolve, 0));
        const query = new URLSearchParams(params.toString());

        if (pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year) {
          const start = new Date(
            pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("start", start);
        }

        if (pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year) {

          const date = new Date(
            pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year
          )
          const end = [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0"),
          ].join("-");
          query.append("end", end);
        }

        if (pageStore.selected_one_department)
          query.append("departament", pageStore.selected_one_department);
        if (pageStore.selected_organization)
          query.append("orgs", pageStore.selected_organization);
        if (pageStore.selected_staff_years)
          query.append("staff_year", pageStore.selected_staff_years)

        query.append("page", page);
        query.append("count", count);

        const res = await authFetch(`${baseUrl}/api/postoplat?${query}`, {
          method: "GET",
          signal: signal,
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${pageStore.token}`,
            "X-Database": pageStore.select_backup != "" ? "temp" : "main"
          },
        });
        const json = await res.json();
        const data = json.data || [];
        if (page === 0) total = json.total || 0;

        pageStore.addDataPayments(data);
        //if (data.length < count || pageStore.data_payments.length >= total)
        break;
      }
    } catch (err) {
      toast({
        title: "Ошибка загрузки платежей",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.abortControllerRef = null;
      pageStore.setLoading(false)
      setLoading(false);
      stopTimer();
    }
  };

  const fetchAllStaff = async () => {
    setLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataStaff();
    let page = 0;
    const count = 1000;
    let total = 0;

    try {
      while (true) {
        await new Promise(resolve => setTimeout(resolve, 0));
        const query = new URLSearchParams(params.toString());

        if (pageStore.start_date_month || pageStore.start_date_year) {
          const start = new Date(
            pageStore.start_date_month || pageStore.start_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("start", start);
        }

        if (pageStore.end_date_month || pageStore.end_date_year) {

          const date = new Date(
            pageStore.end_date_month || pageStore.end_date_year
          )
          const end = [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0"),
          ].join("-");
          query.append("end", end);
        }

        query.append("page", page);
        query.append("count", count);

        const res = await authFetch(`${baseUrl}/api/staff?${query}`, {
          method: "GET",
          signal: signal,
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${pageStore.token}`,
            "X-Database": pageStore.select_backup != "" ? "temp" : "main"
          },
        });
        const json = await res.json();
        const data = json.data || [];
        if (page === 0) total = json.total || 0;

        pageStore.addDataStaff(data);
        break;
      }
    } catch (err) {
      toast({
        title: "Ошибка загрузки платежей",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.abortControllerRef = null;
      pageStore.setLoading(false)
      setLoading(false);
      stopTimer();
    }
  };

  const fetchAllDebitors = async () => {
    setLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataDebitors();
    let page = 0;
    const count = 1000;
    let total = 0;

    try {
      while (true) {
        await new Promise(resolve => setTimeout(resolve, 0));
        const query = new URLSearchParams(params.toString());

        if (pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year) {
          const start = new Date(
            pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("start", start);
        }
        if (pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year) {
          const end = new Date(
            pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("end", end);
        }
        if (pageStore.selected_one_agent)
          query.append("partners", pageStore.selected_one_agent);
        if (pageStore.selected_one_department)
          query.append("departament_name", pageStore.selected_one_department);
        if (pageStore.selected_one_account_number)
          query.append("nums", pageStore.selected_one_account_number);
        if (pageStore.selected_view && (pageStore.selected_view.isReturn || pageStore.selected_view.isNotReturn)) {
          if (pageStore.selected_view.isReturn && !pageStore.selected_view.isNotReturn) query.append("isReturn", 1);
          else if (!pageStore.selected_view.isReturn && pageStore.selected_view.isNotReturn) query.append("isReturn", 0);
          else query.append("isReturn", 3)
        }
        // % отгрузки фильтруется на клиенте (чекбоксы 0 / 1-98 / 50 / 99 / 100)
        if (pageStore.selected_staff_years)
          query.append("staff_year", pageStore.selected_staff_years)

        query.append("page", page);
        query.append("count", count);

        const res = await authFetch(`${baseUrl}/api/debitors?${query}`, {
          method: "GET",
          signal: signal,
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${pageStore.token}`,
            "X-Database": pageStore.select_backup != "" ? "temp" : "main"
          },
        });
        const json = await res.json();
        const data = json.data || [];
        if (page === 0) total = json.total || 0;

        pageStore.addDataDebitors(data);
        break;
      }
    } catch (err) {
      toast({
        title: "Ошибка загрузки дебиторов",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.abortControllerRef = null;
      setLoading(false);
      stopTimer();
      pageStore.setLoading(false)
    }
  };

  const fetchAllPDZ = async () => {
    setLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataPDZ();
    let page = 0;
    const count = 1000;
    let total = 0;

    try {
      while (true) {
        await new Promise(resolve => setTimeout(resolve, 0));
        const query = new URLSearchParams(params.toString());

        if (pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year) {
          const start = new Date(
            pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("start", start);
        }
        if (pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year) {
          const end = new Date(
            pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("end", end);
        }
        if (pageStore.selected_one_agent)
          query.append("partners", pageStore.selected_one_agent);
        if (pageStore.selected_one_department)
          query.append("departament_name", pageStore.selected_one_department);
        if (pageStore.selected_one_account_number)
          query.append("nums", pageStore.selected_one_account_number);
        if (pageStore.selected_view && (pageStore.selected_view.isReturn || pageStore.selected_view.isNotReturn)) {
          if (pageStore.selected_view.isReturn && !pageStore.selected_view.isNotReturn) query.append("isReturn", 1);
          else if (!pageStore.selected_view.isReturn && pageStore.selected_view.isNotReturn) query.append("isReturn", 0);
          else query.append("isReturn", 3)
        }
        if (pageStore.selected_view && pageStore.selected_view.isFullShipment) {
          query.append("isFullShipment", "true");
        }
        if (pageStore.selected_view && pageStore.selected_view.isPartialShipment) {
          query.append("isPartialShipment", "true");
        }
        if (pageStore.selected_staff_years)
          query.append("staff_year", pageStore.selected_staff_years)

        query.append("page", page);
        query.append("count", count);

        const res = await authFetch(`${baseUrl}/api/pdz?${query}`, {
          method: "GET",
          signal: signal,
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${pageStore.token}`,
            "X-Database": pageStore.select_backup != "" ? "temp" : "main"
          },
        });
        const json = await res.json();
        const data = json.data || [];
        if (page === 0) total = json.total || 0;

        pageStore.addDataPDZ(data);
        break;
      }
    } catch (err) {
      toast({
        title: "Ошибка загрузки дебиторов",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.abortControllerRef = null;
      setLoading(false);
      stopTimer();
      pageStore.setLoading(false)
    }
  };

  // «Просроченная ДЗ (ПДЗ)»: периода нет — его задаёт правило отчёта
  // (счета с 01.01.2024 по сегодня), остальные фильтры — как у «Счетов».
  const fetchAllOverdue = async () => {
    setLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataOverdue();
    try {
      const query = new URLSearchParams(params.toString());
      (pageStore.selected_agents || []).forEach((partner) => query.append("partners", partner));
      if (pageStore.selected_one_department)
        query.append("departament_name", pageStore.selected_one_department);
      const res = await authFetch(`${baseUrl}/api/overdue_receivables?${query}`, {
        method: "GET",
        signal: signal,
        headers: {
          accept: "application/json",
          "X-Database": pageStore.select_backup != "" ? "temp" : "main"
        },
      });
      const json = await res.json();
      if (json.error) throw new Error(json.error);
      pageStore.setDataOverdue(json.data || [], json.as_of);
    } catch (err) {
      toast({
        title: "Ошибка загрузки просроченной ДЗ",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.abortControllerRef = null;
      setLoading(false);
      stopTimer();
      pageStore.setLoading(false)
    }
  };

  const fetchAllOrderSuppliers = async () => {
    setLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataOrderSuppliers();
    let page = 0;
    const count = 1000;
    let total = 0;

    try {
      while (true) {
        await new Promise(resolve => setTimeout(resolve, 0));
        const query = new URLSearchParams(params.toString());

        if (pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year) {
          const start = new Date(
            pageStore.start_date_day || pageStore.start_date_month || pageStore.start_date_year
          )
            .toISOString()
            .split("T")[0];
          query.append("start", start);
        }

        if (pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year) {
          const date = new Date(
            pageStore.end_date_day || pageStore.end_date_month || pageStore.end_date_year
          )
          const end = [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0"),
          ].join("-");
          query.append("end", end);
        }

        // общие фильтры
        if (pageStore.selected_one_department)
          query.append("departament", pageStore.selected_one_department);
        if (pageStore.selected_staff_years)
          query.append("staff_year", pageStore.selected_staff_years);

        // юрлицо (как orgs в payments/openProfit)
        if (pageStore.os_legal_entity_filter)
          query.append("orgs", pageStore.os_legal_entity_filter);

        // Примечание: 4 поисковых фильтра (внутренний код, код оплаты, ID сделки,
        // счёт) теперь применяются на клиенте в table_data.jsx — здесь не отправляем.

        query.append("page", page);
        query.append("count", count);

        const res = await authFetch(`${baseUrl}/api/order_suppliers?${query}`, {
          method: "GET",
          signal: signal,
          headers: {
            accept: "application/json",
            "X-Database": pageStore.select_backup != "" ? "temp" : "main"
          },
        });
        const json = await res.json();
        const data = json.data || [];
        if (page === 0) total = json.total || 0;

        pageStore.addDataOrderSuppliers(data);
        break;
      }
    } catch (err) {
      toast({
        title: "Ошибка загрузки заказов поставщикам",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.abortControllerRef = null;
      setLoading(false);
      stopTimer();
      pageStore.setLoading(false)
    }
  };

  const buttons = (
    <>
      <Button
        onClick={page === "staff" ? fetchAllStaff : page === "payments" ? fetchAllPayments : page === "openRev" ? fetchAllOpenRev : page === "openProfit" ? fetchAllOpenProfit : page === "pdz" ? fetchAllPDZ : page === "orderSuppliers" ? fetchAllOrderSuppliers : page === "overdue" ? fetchAllOverdue : fetchAllDebitors}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        isLoading={loading}
        _hover={{
          background: "#444",
        }}
        mr={3}
      >
        Сформировать
      </Button>
      <Button
        onClick={() => page === "payments" ? pageStore.resetPaymentFilters() : page === "orderSuppliers" ? pageStore.resetOrderSupplierFilters() : pageStore.resetFilters()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
        mr={3}
      >
        Сбросить фильтры
      </Button>
      <Button
        onClick={() => handleCancel()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
      >
        Отменить запрос
      </Button>
    </>
  )

  return (
    <>
      <Box position="relative" w="100%">
        <VStack width="100%" align="center">
          {/* Пока блок раскрыт, не обрезаем выпадающие списки: у «Просроченной ДЗ»
              поле «Контрагенты» стоит в последнем ряду, и его список уходил под
              нижний край блока. Так же сделано в фильтрах «Оплат». */}
          <Collapse
            in={pageStore.open_filter}
            animateOpacity
            style={{ overflow: pageStore.open_filter ? "visible" : "hidden" }}
          >
            <Box w="100%">
              {page === "payments" ? (
                <VStack w="100%" gap="25px">
                  <Flex
                    justify="center"
                    wrap="wrap"
                    gap={2}
                    direction={{ base: "column", sm: "row" }}
                    align="center"
                  >
                    <Text whiteSpace={"nowrap"} fontSize={"16px"} fontWeight={"600"} textColor={"white"}>Период оплат:</Text>
                    <HStack>
                      <SelectDateDays />
                      <SelectDateMonth />
                      <SelectDateYear />
                    </HStack>
                  </Flex>
                  <Flex
                    direction={{ base: "column", lg: "row" }}
                    gap={4}
                    align="center"
                    w="100%"
                    justify="center"
                  >
                    <HStack alignItems={"start"}>
                      <Text fontWeight={"600"} fontSize={"16px"} color={"myColor.white"}>
                        Менеджеры:
                      </Text>
                      <ModalSelectManagers left={"-300px"} />
                    </HStack>
                    <Flex wrap="wrap" justify="center" gap={2}>
                      <HStack>
                        <SelectOrganization />
                        <SelectSection />
                      </HStack>
                      <HStack>
                        <SelectTypeOrder />
                        <SelectGroupBy />
                      </HStack>
                    </Flex>
                  </Flex>
                  <Flex
                    wrap="wrap"
                    justify="center"
                    gap={4}
                    direction={{ base: "column", sm: "row" }}
                    align={{ base: "stretch", sm: "start" }}
                  >
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      color="#EEEEEE"
                      w={{ base: "100%", sm: "auto" }}
                      h="fit-content" // Дополнительно указываем высоту по контенту
                    >
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.absolute_column_payments}
                        onChange={(e) => pageStore.setAbsoluteColumnPayments(e.target.checked)}
                        size={{ base: "sm", md: "md" }}
                      >
                        Абсолютные значения
                      </Checkbox>
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.percent_column_payments}
                        onChange={(e) => pageStore.setPercentColumnPayments(e.target.checked)}
                        size={{ base: "sm", md: "md" }}
                      >
                        Прирост, %
                      </Checkbox>
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.part_column_payments}
                        onChange={(e) => pageStore.setPartColumnPayments(e.target.checked)}
                        size={{ base: "sm", md: "md" }}
                      >
                        Доли, %
                      </Checkbox>
                    </VStack>
                    <ModalSelectStaffYears />
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      color="#EEEEEE"
                      w={{ base: "100%", sm: "auto" }}
                      h="fit-content" // Дополнительно указываем высоту по контенту
                    >
                      <Checkbox
                        size={{ base: "sm", md: "md" }}
                        colorScheme="green"
                        isChecked={pageStore.workers}
                        onChange={(e) => pageStore.setWorkers(e.target.checked)}
                      >
                        Работающие
                      </Checkbox>
                    </VStack>
                    <SelectBackup />
                    <SelectBind report_name={"payments"} />
                  </Flex>
                  <HStack w="100%">
                    <SelectPeriod />
                  </HStack>
                </VStack >
              ) : page === "openRev" ? (
                <VStack w="100%" gap="25px">
                  <Flex
                    justify="center"
                    wrap="wrap"
                    gap={2}
                    direction={{ base: "column", sm: "row" }}
                    align="center"
                  >
                    <Text whiteSpace={"nowrap"} fontSize={"16px"} fontWeight={"600"} textColor={"white"}>Период открытий выручки:</Text>
                    <HStack>
                      <SelectDateDays />
                      <SelectDateMonth />
                      <SelectDateYear />
                    </HStack>
                  </Flex>
                  <Flex
                    direction={{ base: "column", lg: "row" }}
                    gap={4}
                    align="center"
                    w="100%"
                    justify="center"
                  >
                    <HStack alignItems={"start"}>
                      <Text fontWeight={"600"} fontSize={"16px"} color={"myColor.white"}>
                        Менеджеры:
                      </Text>
                      <ModalSelectManagers left={"-300px"} />
                    </HStack>
                    <Flex wrap="wrap" justify="center" gap={2}>
                      <HStack>
                        <SelectOrganization />
                        <SelectSection />
                      </HStack>
                      <HStack>
                        <SelectTypeOrder />
                        <SelectGroupBy />
                      </HStack>
                    </Flex>
                  </Flex>
                  <Flex
                    wrap="wrap"
                    justify="center"
                    gap={4}
                    direction={{ base: "column", sm: "row" }}
                    align={{ base: "stretch", sm: "start" }}
                  >
                    <IsReturnAndPaidOpen />
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      width="250px"
                      color="#EEEEEE"
                      w={{ base: "100%", sm: "auto" }}
                      h="fit-content" // Дополнительно указываем высоту по контенту
                    >
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.absolute_column_openRev}
                        onChange={(e) => pageStore.setAbsoluteColumnOpenRev(e.target.checked)}
                        size={{ base: "sm", md: "md" }}
                      >
                        Абсолютные значения
                      </Checkbox>
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.percent_column_openRev}
                        onChange={(e) => pageStore.setPercentColumnOpenRev(e.target.checked)}
                        size={{ base: "sm", md: "md" }}
                      >
                        Прирост, %
                      </Checkbox>
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.part_column_openRev}
                        onChange={(e) => pageStore.setPartColumnOpenRev(e.target.checked)}
                        size={{ base: "sm", md: "md" }}
                      >
                        Доли, %
                      </Checkbox>
                    </VStack>
                    <ModalSelectStaffYears />
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      width="250px"
                      color="#EEEEEE"
                      w={{ base: "100%", sm: "auto" }}
                      h="fit-content" // Дополнительно указываем высоту по контенту
                    >
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.workers}
                        onChange={(e) => pageStore.setWorkers(e.target.checked)}
                        size={{ base: "sm", md: "md" }}
                      >
                        Работающие
                      </Checkbox>
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.isSelf}
                        onChange={(e) => pageStore.setIsSelf(e.target.checked)}
                      >
                        Собственные счета
                      </Checkbox>
                    </VStack>
                    <SelectBackup />
                    <SelectBind report_name={"openRev"} />
                  </Flex>
                  <HStack w="100%">
                    <SelectPeriod />
                  </HStack>
                </VStack>
              ) : page === "openProfit" ? (
                <VStack w="100%" gap="25px">
                  <Flex
                    justify="center"
                    wrap="wrap"
                    gap={2}
                    direction={{ base: "column", sm: "row" }}
                    align="center"
                  >
                    <Text whiteSpace={"nowrap"} fontSize={"16px"} fontWeight={"600"} textColor={"white"}>Период открытий Прибыли:</Text>
                    <HStack>
                      <SelectDateDays />
                      <SelectDateMonth />
                      <SelectDateYear />
                    </HStack>
                  </Flex>
                  <Flex
                    direction={{ base: "column", lg: "row" }}
                    gap={4}
                    align="center"
                    w="100%"
                    justify="center"
                  >
                    <HStack alignItems={"start"}>
                      <Text fontWeight={"600"} fontSize={"16px"} color={"myColor.white"}>
                        Менеджеры:
                      </Text>
                      <ModalSelectManagers left={"-300px"} />
                    </HStack>
                    <Flex wrap="wrap" justify="center" gap={2}>
                      <HStack >
                        <SelectOrganization />
                        <SelectSection />
                      </HStack>
                      <HStack>
                        <SelectTypeOrder />
                        <SelectGroupBy />
                      </HStack>
                    </Flex>
                  </Flex>
                  <Flex
                    wrap="wrap"
                    justify="center"
                    gap={4}
                    direction={{ base: "column", sm: "row" }}
                    align={{ base: "stretch", sm: "start" }}
                  >
                    <IsReturnAndPaidOpen />
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      width="250px"
                      color="#EEEEEE"
                    >
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.absolute_column_openProfit}
                        onChange={(e) => pageStore.setAbsoluteColumnOpenProfit(e.target.checked)}
                        w={{ base: "100%", sm: "auto" }}
                        h="fit-content"
                      >
                        Абсолютные значения
                      </Checkbox>
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.percent_column_openProfit}
                        onChange={(e) => pageStore.setPercentColumnOpenProfit(e.target.checked)}
                        w={{ base: "100%", sm: "auto" }}
                        h="fit-content"
                      >
                        Прирост, %
                      </Checkbox>
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.part_column_openProfit}
                        onChange={(e) => pageStore.setPartColumnOpenProfit(e.target.checked)}
                        w={{ base: "100%", sm: "auto" }}
                        h="fit-content"
                      >
                        Доли, %
                      </Checkbox>
                    </VStack>
                    <ModalSelectStaffYears />
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      width="250px"
                      color="#EEEEEE"
                    >
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.workers}
                        onChange={(e) => pageStore.setWorkers(e.target.checked)}
                        w={{ base: "100%", sm: "auto" }}
                        h="fit-content"
                      >
                        Работающие
                      </Checkbox>
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.isSelf}
                        onChange={(e) => pageStore.setIsSelf(e.target.checked)}
                      >
                        Собственные счета
                      </Checkbox>
                    </VStack>
                    <SelectBackup />
                    <SelectBind report_name={"openProfit"} />
                  </Flex>
                  <HStack w="100%">
                    <SelectPeriod />
                  </HStack>
                </VStack>
              ) : page === "staff" ? (
                <VStack w="100%" gap="50px">
                  <Flex
                    justify="center"
                    wrap="wrap"
                    gap={2}
                    direction={{ base: "column", sm: "row" }}
                    align="center"
                  >
                    <Text whiteSpace={"nowrap"} fontSize={"16px"} fontWeight={"600"} textColor={"white"}>Период:</Text>
                    <HStack>
                      <SelectDateMonth />
                      <SelectDateYear />
                    </HStack>
                  </Flex>
                  <HStack>
                    <SelectGroupBy />
                    <SelectBind report_name={"staff"} />
                  </HStack>
                </VStack>
              ) : page === "pdz" ? (
                <VStack w="100%" gap="10px">
                  <Flex
                    justify="center"
                    wrap="wrap"
                    gap={2}
                    direction={{ base: "column", sm: "row" }}
                    align="center"
                  >
                    <Text whiteSpace={"nowrap"} fontSize={"16px"} fontWeight={"600"} textColor={"white"}>Период карточек счетов:</Text>
                    <HStack>
                      <SelectDateDays />
                      <SelectDateMonth />
                      <SelectDateYear />
                    </HStack>
                  </Flex>
                  <Flex
                    direction={{ base: "column", lg: "row" }}
                    gap={4}
                    align="center"
                    w="100%"
                    justify="center"
                  >
                    <HStack alignItems={"start"}>
                      <Text fontWeight={"600"} fontSize={"12px"} color={"myColor.white"}>
                        Менеджеры:
                      </Text>
                      <ModalSelectManagers />
                      <SelectSection />
                    </HStack>
                    <Flex wrap="wrap" justify="center" gap={2}>
                      <HStack>
                        <SelectGroupByPDZ />
                        <SelectCounteragent />
                      </HStack>
                      <HStack>
                        <SelectAccountNumber />
                      </HStack>
                    </Flex>
                  </Flex>
                  <Flex
                    wrap="wrap"
                    justify="center"
                    gap={4}
                    direction={{ base: "column", sm: "row" }}
                    align={{ base: "stretch", sm: "start" }}
                  >
                    <IsReturnAndPaid />
                    <ModalSelectStaffYears />
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      width="250px"
                      color="#EEEEEE"
                      h="fit-content"
                      w={{ base: "100%", sm: "auto" }}
                    >
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.workers}
                        onChange={(e) => pageStore.setWorkers(e.target.checked)}
                        size={{ base: "sm", md: "md" }}
                      >
                        Работающие
                      </Checkbox>
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.isSelf}
                        onChange={(e) => pageStore.setIsSelf(e.target.checked)}
                      >
                        Собственные счета
                      </Checkbox>
                    </VStack>
                    <SelectBackup />
                    <SelectBind report_name={"pdz"} />
                  </Flex>
                  <HStack w="100%">
                    <SelectPeriod />
                  </HStack>
                </VStack>
              ) : page === "overdue" ? (
                <VStack w="100%" gap="20px">
                  <Text fontSize={"14px"} color={"gray.400"} textAlign="center">
                    Счета с 01.01.2024 по сегодня: открыты, отгружены, срок оплаты прошёл, долг больше нуля.
                  </Text>
                  <Flex
                    direction={{ base: "column", lg: "row" }}
                    gap={4}
                    align="center"
                    w="100%"
                    justify="center"
                  >
                    <HStack alignItems={"start"}>
                      <Text fontWeight={"600"} fontSize={"12px"} color={"myColor.white"}>
                        Менеджеры:
                      </Text>
                      <ModalSelectManagers />
                      <SelectSection />
                    </HStack>
                    <HStack alignItems={"start"}>
                      <Text fontWeight={"600"} fontSize={"12px"} color={"myColor.white"}>
                        Контрагенты:
                      </Text>
                      <ModalSelectPartners />
                    </HStack>
                    <SelectBackup />
                  </Flex>
                </VStack>
              ) : page === "orderSuppliers" ? (
                <VStack w="100%" gap="20px">
                  <Flex
                    justify="center"
                    wrap="wrap"
                    gap={2}
                    direction={{ base: "column", sm: "row" }}
                    align="center"
                  >
                    <Text whiteSpace={"nowrap"} fontSize={"16px"} fontWeight={"600"} textColor={"white"}>Период (Дата начала):</Text>
                    <HStack>
                      <SelectDateDays />
                      <SelectDateMonth />
                      <SelectDateYear />
                    </HStack>
                  </Flex>
                  <Flex
                    direction={{ base: "column", lg: "row" }}
                    gap={4}
                    align="center"
                    w="100%"
                    justify="center"
                  >
                    <HStack alignItems={"start"}>
                      <Text fontWeight={"600"} fontSize={"16px"} color={"myColor.white"}>
                        Ответственные:
                      </Text>
                      <ModalSelectManagers left={"-300px"} />
                      <SelectSection />
                    </HStack>
                    <Flex wrap="wrap" justify="center" gap={2}>
                      <HStack>
                        <SelectLegalEntity />
                        <SelectStage />
                      </HStack>
                    </Flex>
                  </Flex>
                  <Flex
                    wrap="wrap"
                    justify="center"
                    gap={4}
                    direction={{ base: "column", sm: "row" }}
                    align={{ base: "stretch", sm: "start" }}
                  >
                    <SelectBackup />
                    <SelectBind report_name={"orderSuppliers"} />
                  </Flex>

                  {/* Примечание: 4 поисковых фильтра (Внутренний код, Код оплаты в Б24,
                      ID сделки, Счёт) перенесены в таблицу (table_data.jsx) и работают
                      как клиентская фильтрация уже загруженных данных. */}

                  <HStack w="100%">
                    <SelectPeriod />
                  </HStack>
                </VStack>
              ) : (
                <VStack w="100%" gap="10px">
                  <Flex
                    justify="center"
                    wrap="wrap"
                    gap={2}
                    direction={{ base: "column", sm: "row" }}
                    align="center"
                  >
                    <Text whiteSpace={"nowrap"} fontSize={"16px"} fontWeight={"600"} textColor={"white"}>Период счетов:</Text>
                    <HStack>
                      <SelectDateDays />
                      <SelectDateMonth />
                      <SelectDateYear />
                    </HStack>
                  </Flex>
                  <Flex
                    direction={{ base: "column", lg: "row" }}
                    gap={4}
                    align="center"
                    w="100%"
                    justify="center"
                  >
                    <HStack alignItems={"start"}>
                      <Text fontWeight={"600"} fontSize={"12px"} color={"myColor.white"}>
                        Менеджеры:
                      </Text>
                      <ModalSelectManagers />
                      <SelectSection />
                    </HStack>
                    <Flex wrap="wrap" justify="center" gap={2}>
                      <HStack>
                        <SelectGroupByOrders />
                        <SelectCounteragent />
                      </HStack>
                      <HStack>
                        <SelectAccountNumber />
                      </HStack>
                    </Flex>
                  </Flex>
                  <Flex
                    wrap="wrap"
                    justify="center"
                    gap={4}
                    direction={{ base: "column", sm: "row" }}
                    align={{ base: "stretch", sm: "start" }}
                  >
                    <IsReturnAndPaid showShipment={false} />
                    <ShipmentPercentFilter />
                    <ModalSelectStaffYears />
                    {/* Заменяем HStack на VStack */}
                    <VStack align="stretch" spacing={2} w={{ base: "100%", sm: "auto" }}>
                      <VStack
                        align="start"
                        spacing={2}
                        bg="#333"
                        p={3}
                        borderRadius="10px"
                        width="250px"
                        color="#EEEEEE"
                        w={{ base: "100%", sm: "auto" }}
                        h="fit-content"
                      >
                        <Checkbox
                          colorScheme="green"
                          isChecked={pageStore.workers}
                          onChange={(e) => pageStore.setWorkers(e.target.checked)}
                          size={{ base: "sm", md: "md" }}
                        >
                          Работающие
                        </Checkbox>
                      </VStack>

                      <VStack
                        align="start"
                        spacing={2}
                        bg="#333"
                        p={3}
                        borderRadius="10px"
                        width="250px"
                        color="#EEEEEE"
                        w={{ base: "100%", sm: "auto" }}
                        h="fit-content"
                      >
                        <Checkbox
                          colorScheme="green"
                          isChecked={pageStore.isSelf}
                          onChange={(e) => pageStore.setIsSelf(e.target.checked)}
                          size={{ base: "sm", md: "md" }}
                        >
                          Собственные счета
                        </Checkbox>
                      </VStack>
                    </VStack>
                    <SelectBackup />
                    <SelectBind report_name={"debitor"} />
                  </Flex>
                  <HStack w="100%">
                    <SelectPeriod />
                  </HStack>
                </VStack>
              )}
            </Box>
          </Collapse>
        </VStack >
      </Box>

      <Collapse in={pageStore.open_filter} animateOpacity>
        {renderButtons ? renderButtons(buttons) : buttons}
      </Collapse>
    </>
  );
});

export default FiltersGrid;
